<template>
  <div>
    <img ref="img" />
  </div>
</template>

<script>
  import Cropper from 'cropperjs'

  export default {
    name: 'cropper',
    props: {
      file: File,
      required: true
    },
    mounted () {
      this.$refs.img.file = this.file

      const reader = new FileReader()
      reader.onload = (e) => { this.$refs.img.src = e.target.result }
      reader.readAsDataURL(this.file)

      this.$refs.img.onload = (e) => {
        const cropperInstance = new Cropper(this.$refs.img, {
          aspectRatio: 1,
          viewMode: 2,
          minCropBoxWidth: 64,
          minCropBoxHeight: 64,
          toggleDragModeOnDblclick: false,
          ready: (e) => {
            this.$emit('cropperLoaded', e.target.cropper)
          }
        })
        ;(() => {})(cropperInstance) // Hacking linter 'no-unused-vars' rule
      }
    }
  }
</script>

<style lang="scss" scoped >
  img {
    max-width: 100%;
    display: block;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Cropper.vue